import { string, number, date, array } from 'yup'
import dayjs from 'dayjs'

export const globalRules = new Map<string, any>([
  [
    'required-array',
    () => array().min(1, 'form.valid.minArray').required('form.valid.required')
  ],
  ['required', () => string().required('form.valid.required')],
  ['upper', () => string().matches(/^[A-Z]+$/, 'form.valid.upper')],
  [
    'regex',
    (regex: RegExp, message = 'form.valid.regex') =>
      string().matches(regex, {
        excludeEmptyString: true,
        message
      })
  ],
  ['email', () => string().email('form.valid.email')],
  ['url', () => string().url('form.valid.url')],
  [
    'date',
    () =>
      date()
        .transform(_ => (isNaN(new Date(_).getTime()) ? undefined : _))
        .typeError('form.valid.date')
  ],
  [
    'number',
    () =>
      number()
        .transform(_ => (isNaN(_) ? undefined : _))
        .typeError('form.valid.number')
  ],
  [
    'decimal',
    (maxWhole: string = '8', maxDecimal: string = '8') =>
      string().matches(
        new RegExp(
          `(^\\-?[0-9]{1,${maxWhole}}$|^\\-?[0-9]{1,${maxWhole}}\\.[0-9]{1,${maxDecimal}}$)`
        ),
        {
          excludeEmptyString: true,
          message: `form.valid.decimal//${maxWhole},${maxDecimal}`
        }
      )
  ],
  ['positive', () => number().positive('form.valid.positive')],
  [
    'integer',
    () =>
      string().matches(/^\d+$/, {
        excludeEmptyString: true,
        message: 'form.valid.integer'
      })
  ],
  [
    'alphanumeric',
    () =>
      string().matches(/^[A-Za-z0-9À-ÿ\u00f1\u00d1\s-_&()]+$/, {
        excludeEmptyString: true,
        message: 'form.valid.alphanumeric'
      })
  ],
  [
    'onlyletters',
    () =>
      string().matches(/^[A-Za-zÀ-ÿ\s]+$/, {
        excludeEmptyString: true,
        message: 'form.valid.onlyletters'
      })
  ],
  [
    'min',
    (min: number) =>
      number()
        .transform(_ => (isNaN(_) ? undefined : _))
        .min(min, `form.valid.minNumber//${min}`)
  ],
  [
    'max',
    (max: number) =>
      number()
        .transform(_ => (isNaN(_) ? undefined : _))
        .max(max, `form.valid.maxNumber//${max}`)
  ],
  [
    'between',
    (min: number, max: number) =>
      number()
        .min(min, `form.valid.minNumber//${min}`)
        .max(max, `form.valid.maxNumber//${max}`)
  ],
  [
    'before',
    (dateStart: string) => {
      if (dateStart === '') {
        return date().transform(_ =>
          isNaN(new Date(_).getTime()) ? undefined : _
        )
      } else {
        return date()
          .transform(_ => (isNaN(new Date(_).getTime()) ? undefined : _))
          .min(
            dateStart,
            `form.valid.maxDate//${dayjs(dateStart).format('DD/MM/YYYY')}`
          )
      }
    }
  ],
  [
    'minlength',
    (min: number) => string().min(min, `form.valid.minLength//${min}`)
  ],
  [
    'maxlength',
    (max: number) => string().max(max, `form.valid.maxLength//${max}`)
  ],
  [
    'file',
    (...extensions: string[]) =>
      string().test(
        'fileFormat',
        `form.valid.maxLength//${extensions.join()}`,
        value => {
          const allowedExtensions = extensions
          let extensionFile: any
          if (value !== undefined && value !== '') {
            extensionFile = value.split('.').pop()
            return allowedExtensions.includes(extensionFile.toLowerCase())
          } else {
            return true
          }
        }
      )
  ]
])
